/* eslint-disable prettier/prettier */
import { IRequestConfig, IRequestOptions } from '@/shared/services/index'
import { AxiosInstance } from 'axios'
import { getCookie } from 'cookies-next'

interface ServiceOptions {
    axios?: AxiosInstance
  }

  // Add default options
  export const serviceOptionsReportCall: ServiceOptions = {}

  // Instance selector
  function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptionsReportCall.axios) {
      return serviceOptionsReportCall.axios
        .request(configs)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    } else {
      throw new Error('please inject yourself instance like axios  ')
    }
  }

  function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url }
    configs.headers = {
      ...options.headers,
      'Content-Type': contentType,
      Authorization: getCookie('access-token')?'Bearer ' + getCookie('access-token'):''
    }
    return configs
  }

const basePath = ''

export class CallService {
    /**
     *
     */
    static startCall(
      params: {
        /**  */
        callId: string;
        /** requestBody */
        body?: StartCallRequest;
      } = {} as any,
      options: IRequestOptions = {}
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/call/{callId}/start';
        url = url.replace('{callId}', params['callId'] + '');

        const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

        let data = params.body;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }
    /**
     *
     */
    static endCall(
      params: {
        /**  */
        callId: string;
        /** requestBody */
        body?: EndCallRequest;
      } = {} as any,
      options: IRequestOptions = {}
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/call/{callId}/end';
        url = url.replace('{callId}', params['callId'] + '');

        const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

        let data = params.body;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }
    /**
     *
     */
    static actionCall(
      params: {
        /**  */
        callId: string;
        /** requestBody */
        body?: ActionCallRequest;
      } = {} as any,
      options: IRequestOptions = {}
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/call/{callId}/action';
        url = url.replace('{callId}', params['callId'] + '');

        const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

        let data = params.body;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }
    /**
     *
     */
    static handlerEvent(options: IRequestOptions = {}): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/call/event';

        const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

        let data = null;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }
    /**
     *
     */
    static getListCallHistory(
      params: {
        /** Trang */
        page?: number;
        /** Số lượng */
        size?: number;
      } = {} as any,
      options: IRequestOptions = {}
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/call/history';

        const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
        configs.params = { page: params['page'], size: params['size'] };
        let data = null;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }
    /**
     *
     */
    static searchCallHistory(
      params: {
        /** Id chiến dịch */
        campaignId?: string;
        /** Từ ngày */
        fromDate?: number;
        /** Đến ngày */
        toDate?: number;
        /** Từ khóa */
        keyword?: string;
        /** Trạng thái */
        status?: string;
        /** Tương tác */
        keypad?: string;
        /** Trang */
        page?: number;
        /** Số lượng */
        size?: number;
      } = {} as any,
      options: IRequestOptions = {}
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/call/history/search';

        const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
        configs.params = {
          campaign_id: params['campaignId'],
          from_date: params['fromDate'],
          to_date: params['toDate'],
          keyword: params['keyword'],
          status: params['status'],
          keypad: params['keypad'],
          page: params['page'],
          size: params['size']
        };
        let data = null;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }

  /**
   * Lấy chi tiết lịch sử cuộc gọi
   */
  static getCallHistoryDetail(
    params: {
      /** Id cuộc gọi */
      callId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/call/history/' + params['callId']

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  }


  export interface StartCallRequest {
    /** Id người nhận cuộc gọi */
    customer_id: string;

    /** Id chiến dịch */
    campaign_id: string;

    /** Id tổ chức */
    organization_id: string;

    /** Thời điểm tạo cuộc gọi */
    start_time?: number;
  }

  export interface EndCallRequest {
    /** Link lưu trữ cuộc gọi */
    record_url?: string;

    /** Thời điểm tạo cuộc gọi */
    end_time?: number;
  }

  export interface ActionCallRequest {
    /** Phím */
    keypad?: string;

    /** Thời điểm */
    timestamp?: number;
  }